function Text_form_edit(element) {
  this.$element = $(element);

  this.selectors = {
    formParent: 'form[data-i4-decorator="Validator_form"]',
    selectType: '.js-select-type',
    containerHeading: '.js-container-heading',
    containerText: '.js-container-text',
    fieldText: '.js-field-text',
    fieldTitle: '.js-field-title',
    hiddenIsTitle: '.js-hidden-is-title'
  };

  this.triggers = {
    afterLoaded: 'i4:afterLoaded'
  };

  this.data = {
    headingElements: 'heading-elements',
    richtext: 'richtext'
  };

  this.init = function () {
    this.dataHeadingElements = this.$element.data(this.data.headingElements);
    this.dataRichtext = this.$element.data(this.data.richtext);

    this.headingElements = this.dataHeadingElements.split(':');
    this.richtextEnabled = this.dataRichtext === 1;

    this.$formParent = this.$element.parents(this.selectors.formParent);
    this.$selectType = this.$element.find(this.selectors.selectType);
    this.$containerHeading = this.$element.find(this.selectors.containerHeading);
    this.$containerText = this.$element.find(this.selectors.containerText);
    this.$fieldText = this.$element.find(this.selectors.fieldText);
    this.$fieldTitle = this.$element.find(this.selectors.fieldTitle);
    this.$hiddenIsTitle = this.$element.find(this.selectors.hiddenIsTitle);

    this.$selectType.on('i4:change', this.$onChangeType.bind(this));

    this.$containerHeading.hide();
    this.$containerText.hide();

    this.$formParent.on(this.triggers.afterLoaded, (function () {
      if (this.richtextEnabled) {
        this.tinymce = tinymce.get(this.$fieldText.attr('id'));
      }

      this.$onChangeType();
    }).bind(this));
  };

  this.$onChangeType = function () {
    const isHeading = this.headingElements.includes(this.$selectType.val());

    if (this.richtextEnabled) {

      if (this.$containerHeading.is(':visible') && !isHeading) {
        this.tinymce.setContent(this.$fieldTitle.val());
      } else if (this.$containerText.is(':visible') && isHeading) {
        this.$fieldTitle.val(this.tinymce.getContent());
      }

    } else {

      if (this.$containerHeading.is(':visible') && !isHeading) {
        this.$fieldText.val(this.$fieldTitle.val());
      } else if (this.$containerText.is(':visible') && isHeading) {
        this.$fieldTitle.val(this.$fieldText.val());
      }

    }

    if (isHeading) {
      this.$containerHeading.show();
      this.$containerText.hide();
      this.$hiddenIsTitle.val(1);
    } else {
      this.$containerHeading.hide();
      this.$containerText.show();
      this.$hiddenIsTitle.val(0);
    }
  };
}
